import { z } from 'zod'

export const identityRoleSchema = z.enum(['admin', 'member', 'organizationAdmin', 'organizationViewer'])
export type IdentityRole = z.infer<typeof identityRoleSchema>

export const identityRoleLabels = {
  admin: 'admin',
  member: '一般ユーザー',
  organizationAdmin: '組織管理者',
  organizationViewer: '組織閲覧者',
}

export const identityRoleOptions = Object.entries(identityRoleLabels).map(([key, label]) => ({
  value: key,
  label,
}))

export const identityRoleColors: Record<IdentityRole, string> = {
  admin: 'yellow',
  organizationAdmin: 'blue',
  organizationViewer: 'green',
  member: 'green',
}

export function canWriteOrganization(identityRole: IdentityRole) {
  return identityRole === 'admin' || identityRole === 'organizationAdmin'
}
